import React from "react";
import { makeStyles } from "@material-ui/styles";
import styles from "./styles";
import { CgbAccordionBlock } from "../../blocks/CgbAccordionBlock";

const useStyles = makeStyles((theme) => styles(theme));

export default function ProductFaqs(props) {
  // console.log(props);
  const classes = useStyles();

  let faqs = [];

  if (props.faqs !== null) {
    props.faqs.forEach((faq) => {
      faqs.push({
        attributes: {
          className: "",
          open: false,
        },
        innerBlocks: [
          {
            attributes: {
              align: "",
              anchor: "",
              backgroundColor: "",
              className: "",
              content: faq.question,
              level: 3,
              textColor: "",
              __typename: "WpCoreHeadingBlockAttributes",
            },
            innerBlocks: [],
            name: "core/heading",
            __typename: "WpCoreHeadingBlock",
          },
          {
            attributes: {
              align: "",
              backgroundColor: "",
              className: "",
              content: faq.answer,
              direction: "",
              textColor: "",
              __typename: "WpCoreParagraphBlockAttributes",
            },
            innerBlocks: [],
            name: "core/paragraph",
            __typename: "WpCoreParagraphBlock",
          },
        ],
        name: "cgb/accordion-inner",
        __typename: "WpCgbAccordionInnerBlock",
      });
    });
  } else {
    return null;
  }

  return (
    <div
      className={`product-overview  ${classes.ProductFaqs}  ${classes.ProductFaqsTheme}`}
    >
      {props.faqs !== null && (
        <div className="product-faqs">
          <h2>Frequently asked questions</h2>
          <CgbAccordionBlock
            attributes={{
              className: "",
            }}
            innerBlocks={faqs}
          />
        </div>
      )}
    </div>
  );
}
